import ApsModels from "../../models";
import fetcher from "./Fetcher";

class DepartmentHomeSettingsService {
  save = async (data: ApsModels.IDepartmentHomeSettingsInputDto) => {
    const url = "/api/DepartmentHomeSettings";
    return fetcher.post<any>(url, data);
  };

  get = async (deptId: number) => {
    const url = `/api/DepartmentHomeSettings/${deptId}`;
    return fetcher.get<ApsModels.IDepartmentHomeSettingsOutputDto>(url);
  };
}

const departmentHomeSettings = new DepartmentHomeSettingsService();
export default departmentHomeSettings;
